import { connect } from 'react-redux';
//
import DealSearch from 'components/deal-search/deal-search';
import { IStoreState } from 'store';
import { setDealSearchFilter, setDealSearchKeyword, setDealSearchStatusFilter } from 'store/deals/actions';
import { filterDealsBySearchKeyword } from 'store/deals/helpers';
import { getTokenPayload } from 'lib/auth';
import { removeUserGroup } from 'lib/helpers/name-formatters';
import { updateDealField } from 'store/deal-edit/actions';

const mapStateToProps = ({ deals, fieldOptions }: IStoreState) => {
  const { searchFilter, searchKeyword, data, statusFilter } = deals;
  const idTokenResponse = getTokenPayload();
  const employeeName = idTokenResponse ? removeUserGroup(idTokenResponse.name).toLowerCase() : null;

  // Search all field visible on dashboard table
  const fields = ['createdBy', 'createdOn', 'customer', 'modifiedBy', 'modifiedOn', 'name', 'region', 'productLine'];
  const { statuses } = fieldOptions;
  return {
    searchFilter,
    statusFilter,
    searchKeyword,
    filteredDeals: filterDealsBySearchKeyword(employeeName, data, fields, searchFilter, searchKeyword, statusFilter),
    statuses,
  };
};

const mapDispatchToProps = {
  setDealSearchFilter,
  setDealSearchKeyword,
  updateDealField,
  setDealSearchStatusFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealSearch);
